<template>
  <div :class="['rbu-card', { 'grey-overlay': module.ignored }]">
    <div class="rbu-card-header" style="align-items: center">
      <h3 class="px-4 mr-4 d-flex align-center">
        Module {{ String.fromCharCode(65 + module.order_no) }}
      </h3>
      <v-text-field
        outlined
        dense
        hide-details
        label="Name"
        :value="module.name"
        @input="onUpdate({ name: $event })"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-text-field
        outlined
        dense
        hide-details
        label="Portion"
        type="number"
        min="0"
        step=".01"
        suffix="%"
        style="max-width: 100px"
        :value="module.portion"
        @input="onUpdate({ portion: $event })"
      ></v-text-field>
      <v-btn text color="primary" class="ml-4" @click="$emit('delete')"
        >Delete Module
      </v-btn>
      <v-checkbox
        dense
        hide-details
        class="ignore-checkbox ml-4 mb-2"
        :input-value="module.ignored"
        @change="onUpdate({ ignored: $event })"
      >
        <template #label>
          <span
            style="
              font-family: Roboto, sans-serif;
              font-size: 14px;
              font-weight: 500;
              font-stretch: 100%;
              letter-spacing: 1.25px;
              line-height: normal;
              text-indent: 1.25px;
            "
            >IGNORE MODULE</span
          >
        </template>
      </v-checkbox>
    </div>
    <div class="rbu-card-content">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="rbu-section-fluctuation-column-1"></th>
              <th class="rbu-section-fluctuation-column-2 text-right">#</th>
              <th class="rbu-section-fluctuation-column-value">Value</th>
              <th class="rbu-section-fluctuation-column-multiplier"></th>
              <th class="rbu-section-fluctuation-column-formula">Formula</th>
              <th class="rbu-section-fluctuation-column-descriptions">
                Description
              </th>
              <th
                class="rbu-section-fluctuation-column-actions"
                style="width: 20%"
              ></th>
            </tr>
          </thead>
          <tbody>
            <ContractRbuSectionFluctuationRow
              v-for="(fluctuation, idx) in module.fluctuations"
              :key="idx"
              :fluctuation="fluctuation"
              :idx="idx"
              @update="updateFluctuation(idx, $event)"
              @delete="deleteFluctuation($event)"
            >
            </ContractRbuSectionFluctuationRow>
            <tr>
              <td></td>
              <td colspan="9">
                <v-btn outlined color="primary" @click="addFluctuation()"
                  >ADD FLUCTUATION
                </v-btn>
              </td>
            </tr>
            <ContractRbuAdjustment
              :value="module"
              @update="onUpdate"
              :override_digit="true"
              :override_digit_number="15"
            ></ContractRbuAdjustment>
            <tr>
              <td></td>
              <td style="text-align: right">
                Subtotal ({{
                  module.name ||
                  "Module" + String.fromCharCode(65 + module.order_no)
                }}):
              </td>
              <td style="font-weight: bold">
                {{ module.sub_total }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import ContractRbuSectionFluctuationRow from "@/components/contract/ContractRbuSectionFluctuationRow.vue";
import ContractRbuAdjustment from "@/components/contract/ContractRbuAdjustment.vue";
import floatingPointFix from "js-floating-point";

export default {
  name: "ContractRbuSectionFluctuationModule",
  props: {
    section: Object,
    module: Object,
    idx: Number,
  },
  components: {
    ContractRbuAdjustment,
    ContractRbuSectionFluctuationRow,
  },
  setup(props, { root, emit }) {
    const onUpdate = function (evt) {
      console.debug("Module Update: ", evt);

      let updates = {
        ...props.module,
        ...evt,
      };

      let sub_total = 0;
      let full_formula = "";
      updates.fluctuations.forEach((f) => {
        if (f.sub_total && !f.ignored) {
          let _rate_formula = "";
          let _row_formula = "";
          if (f.previous_datapoint && f.current_datapoint) {
            _rate_formula = `${f.current_datapoint.value}/${f.previous_datapoint.value}`;
            if (f.formula) {
              _row_formula = f.formula.replace(
                "{{VALUE}}",
                `(${_rate_formula})`
              );
            } else {
              _row_formula = `(${_rate_formula})`;
            }
          }
          full_formula = `${full_formula} + (${_row_formula})`;
          // const f_total = Math.round(parseFloat(f.sub_total) * 1e15) / 1e15;
          // sub_total = floatingPointFix(sub_total + f_total);
        }
      });

      function applyValueAdjustment() {
        if (updates.adjustment_value && parseFloat(updates.adjustment_value)) {
          if (full_formula) {
            full_formula = `(${full_formula}) + ${updates.adjustment_value}`;
          } else {
            full_formula = `${updates.adjustment_value}`;
          }
          // sub_total = floatingPointFix(
          //   sub_total + parseFloat(updates.adjustment_value)
          // ).toFixed(15);
        }
      }

      function applyPercentageAdjustment() {
        if (
          updates.adjustment_percentage &&
          parseFloat(updates.adjustment_percentage)
        ) {
          if (full_formula) {
            full_formula = `(${full_formula}) * ${updates.adjustment_percentage}`;
          }
          // sub_total = floatingPointFix(
          //   sub_total * parseFloat(updates.adjustment_percentage)
          // );
        }
      }

      if (updates.adjustment_value_first) {
        applyValueAdjustment();
        applyPercentageAdjustment();
      } else {
        applyPercentageAdjustment();
        applyValueAdjustment();
      }

      let eval_value = 0;
      try {
        eval_value = eval(full_formula);
        eval_value = eval_value.toFixed(20);
      } catch (e) {
        console.log(e);
      }

      try {
        sub_total = root.$roundTo15Digits(eval_value);
      } catch (e) {
        console.log(e);
        sub_total = 0;
      }

      if (!updates.portion) {
        updates.portion = 0;
      }

      sub_total = (sub_total * updates.portion) / 100;
      const prec15 = sub_total.toPrecision(15);
      let [integerPart, decimalPart = ""] = prec15.split(".");
      decimalPart = decimalPart.padEnd(15, "0");
      const excelPad = `${integerPart}.${decimalPart}`;
      updates.sub_total = excelPad;
      emit("update", updates);
    };

    const addFluctuation = function () {
      let fluctuations = props.module.fluctuations;

      fluctuations.push({
        previous_period: "BASE_START",
        current_period: "BASE_END",
      });

      onUpdate({ fluctuations });
    };
    const updateFluctuation = function (fluctuationIdx, f) {
      let fluctuations = props.module.fluctuations;
      const original = fluctuations[fluctuationIdx];
      fluctuations.splice(fluctuationIdx, 1, { ...original, ...f });
      onUpdate({ fluctuations });
    };
    const deleteFluctuation = function (fluctuationIdx) {
      let fluctuations = props.module.fluctuations;
      fluctuations.splice(fluctuationIdx, 1);
      onUpdate({ fluctuations });
    };

    return {
      onUpdate,

      addFluctuation,
      updateFluctuation,
      deleteFluctuation,
    };
  },
};
</script>

<style>
.grey-overlay {
  position: relative;
}

.grey-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
  pointer-events: none;
}
</style>
